"use strict";

module.exports = {
  waitExponentialBackoff: waitExponentialBackoff
};

/**
 * Determine the wait time based on retries attempted and exponential backoff.
 *
 * @param {Number} waitSlotTime - The time of each wait slot.
 * @param {Number} attempt - The retry attempt.
 * @param {Number} maxAttempts - The maximum number of slots to be waited will be ((2^maxAttempts) - 1)
 *
 * @returns {Promise} - A promise that resolves when the retry should be attempted once again.
 */
function waitExponentialBackoff() {
  var waitSlotTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
  var attempt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var maxAttempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var waitExponent = Math.min(attempt, maxAttempts);
  var waitSlots = Math.pow(2, waitExponent);
  var waitSlotsForAttempt = Math.floor(Math.random() * waitSlots);
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, waitSlotTime * waitSlotsForAttempt);
  });
}
//# sourceMappingURL=utils.js.map